import * as React from 'react';
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import { Fonts } from 'source/app/presentation/Shared/Styles/SharedStyles';

export function IdentityName({ name }: { name: string }) {
	return (
		<div
			{...Style(`identityName`, {
				...Fonts.iMFell,
				fontSize: `22px`,
				marginBottom: `10px`
			})}
		>
			{name}
		</div>
	);
}
